import { shutdown } from "@intercom/messenger-js-sdk";

export function shutdownIntercomMessenger() {
  if (typeof window.Intercom === "function") {
    shutdown();
  }

  // shutdown() leaves the intercom-id cookie behind, so on a shared workstation
  // the next user would inherit the previous user's anonymous conversations.
  // Cleared even when the SDK isn't loaded, since the cookies may outlive it.
  clearIntercomCookies();
}

function clearIntercomCookies() {
  const intercomCookieNames = document.cookie
    .split(";")
    .map((cookie) => cookie.split("=")[0].trim())
    .filter((cookieName) => cookieName.startsWith("intercom-"));

  // Intercom sets its cookies on the top-level domain (e.g. ".paladin.fr"), and a
  // cookie is only removed when expired with the same domain it was set with.
  const hostnameParts = window.location.hostname.split(".");
  const candidateDomains = hostnameParts.map((_part, index) =>
    hostnameParts.slice(index).join("."),
  );

  for (const cookieName of intercomCookieNames) {
    const expiredCookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    document.cookie = expiredCookie;
    for (const domain of candidateDomains) {
      document.cookie = `${expiredCookie}; domain=${domain}`;
    }
  }
}
